class TalhaoError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TalhaoError';
  }
}

export default TalhaoError;
